import * as joint from "jointjs/dist/joint";

const SelectArea = joint.shapes.standard.Rectangle.define("custom.selectArea", {
  attrs: {
    root: {
      magnet: false,
    },
    z: 100,
    body: {
      fill: "rgba(15, 159, 100, 0.5)",
      stroke: "rgba(15, 159, 100, 1)",
      strokeWidth: 1,
    },
  },
});

export default SelectArea;
